import { styled } from "sharedUI/styles";
import * as Elements from "sharedUI/style";

import { disabledProps } from "webapp/styled-components";

export const Wrapper = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    width: 460px;
    border-radius: 12px;
    background: ${p => p.theme.bgColorLight};
    padding: 20px 20px 0;

    transform: translate(-50%, -50%);
    animation: popit 350ms ease-in-out normal;

    @keyframes popit {
        0% {
            opacity: 0;
            transform: translate(-50%, -50%);
        }
        50% {
            opacity: 1;
            transform: translate(-50%, -50%) scale(1.05);
        }
        100% {
            transform: translate(-50%, -50%);
        }
    }
`;

export const HeadingWrapper = styled.div`
    display: flex;

    > svg {
        color: ${p => p.theme.warningColor};
        margin-right: 8px;
        width: 22px;
        height: 22px;
    }
`;

export const Heading = styled.h3`
    font-family: ${p => p.theme.headerFontFamily};
    font-weight: ${p => p.theme.headerWeight};
    font-size: 18px;
    margin-bottom: 8px;
    max-width: 100%;
`;

export const Desc = styled.div`
    font-size: 16px;
    margin-bottom: 24px;

    a {
        text-decoration: underline !important;
        color: ${p => p.theme.fgColorDark};
    }
`;

export const ButtonRow = styled.div`
    display: flex;
    justify-content: flex-end;
    > button:not(:last-child) {
        margin-right: 8px;
    }
`;

export const Info = styled(Elements.Label)`
    font-weight: ${p => p.theme.heavyFontWeight};
    color: ${p => p.theme.acceptColor};
    flex-grow: 1;
    cursor: pointer;
`;

export const ActionBar = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
`;

export const Button = styled.button<{ isEnabled?: boolean }>`
    cursor: pointer;
    padding: 0 20px;
    height: 32px;
    border-radius: 8px;
    font-family: ${p => p.theme.labelFontFamily};
    margin-left: 8px;
    font-weight: ${p => p.theme.heavyFontWeight};
    font-size: 14px;
    background-color: ${p => p.theme.bgColorMedium};
    color: ${p => p.theme.fgColorMedium};

    ${p => p.isEnabled === false && disabledProps}

    :focus {
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2);
    }
`;

export const AcceptButton = styled(Button)<{ disabled?: boolean }>`
    ${p => p.disabled === true && disabledProps};
    background-color: ${p => p.theme.acceptColor};
    color: ${p => p.theme.button.fgAccept};

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const Input = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: absolute;
    left: 20px;
    p {
        margin: 0 auto;
        padding-left: 10px;
        color: ${p => p.theme.fgColorMedium};
        font-size: 14px;
        font-weight: ${p => p.theme.heavyFontWeight};
        font-family: ${p => p.theme.labelFontFamily};
    }
    input {
        appearance: checkbox;
        width: 20px;
        height: 20px;
        border: 2px solid;
        border-radius: 4px;
        border-color: ${p => p.theme.bgColorMedium};
        padding-right: 10px;
    }
`;
